//
// ███████╗████████╗ █████╗ ████████╗███████╗
// ██╔════╝╚══██╔══╝██╔══██╗╚══██╔══╝██╔════╝
// ███████╗   ██║   ███████║   ██║   █████╗
// ╚════██║   ██║   ██╔══██║   ██║   ██╔══╝
// ███████║   ██║   ██║  ██║   ██║   ███████╗
// ╚══════╝   ╚═╝   ╚═╝  ╚═╝   ╚═╝   ╚══════╝
//
const state = {
  extensions: {},
  selected: [],
  allSelected: false,
  extensionsFilter: {
    extensions_types: [],
    updater_support: [],
    auto_update: []
  }
}

//
//  ██████╗ ███████╗████████╗████████╗███████╗██████╗ ███████╗
// ██╔════╝ ██╔════╝╚══██╔══╝╚══██╔══╝██╔════╝██╔══██╗██╔════╝
// ██║  ███╗█████╗     ██║      ██║   █████╗  ██████╔╝███████╗
// ██║   ██║██╔══╝     ██║      ██║   ██╔══╝  ██╔══██╗╚════██║
// ╚██████╔╝███████╗   ██║      ██║   ███████╗██║  ██║███████║
//  ╚═════╝ ╚══════╝   ╚═╝      ╚═╝   ╚══════╝╚═╝  ╚═╝╚══════╝
//
const getters = {

}

//
// ███╗   ███╗██╗   ██╗████████╗ █████╗ ████████╗██╗ ██████╗ ███╗   ██╗███████╗
// ████╗ ████║██║   ██║╚══██╔══╝██╔══██╗╚══██╔══╝██║██╔═══██╗████╗  ██║██╔════╝
// ██╔████╔██║██║   ██║   ██║   ███████║   ██║   ██║██║   ██║██╔██╗ ██║███████╗
// ██║╚██╔╝██║██║   ██║   ██║   ██╔══██║   ██║   ██║██║   ██║██║╚██╗██║╚════██║
// ██║ ╚═╝ ██║╚██████╔╝   ██║   ██║  ██║   ██║   ██║╚██████╔╝██║ ╚████║███████║
// ╚═╝     ╚═╝ ╚═════╝    ╚═╝   ╚═╝  ╚═╝   ╚═╝   ╚═╝ ╚═════╝ ╚═╝  ╚═══╝╚══════╝
//
const mutations = {
  /**
   * Add an update to the selected extensions array
   *
   * @param state
   * @param payload
   */
  addSelection (state, payload) {
    state.selected.push(payload)
    if (state.selected.length === state.extensions.data.length) {
      state.allSelected = true
    }
  },

  /**
   * Remove an update from the selected extensions array
   *
   * @param state
   * @param payload
   */
  removeSelection (state, payload) {
    state.selected.splice(state.selected.indexOf(payload), 1)
    state.allSelected = false
  },

  /**
   * Set the allSelected property (all sites in the sites view are selected)
   *
   * @param state
   * @param payload
   */
  setSelectAll (state, payload) {
    state.selected = []
    state.extensions.data.forEach((item) => {
      state.selected.push(item.id)
    })
    state.allSelected = true
  },

  setAutoupdate (state, payload) {
    state.extensions.data.forEach((e) => {
      if (e.data.id === payload.id) {
        e.data.autoupdate_enabled = payload.autoupdate
      }
    })
  },

  /**
   * Set extensions array, get data from the backend and convert it for better usage
   *
   * @param state
   * @param payload
   */
  setExtensions (state, payload) {
    // state.sites = payload;
    const data = payload.data
    const meta = payload.meta

    state.extensions.meta = meta
    state.extensions.data = []

    data.forEach((element) => {
      let extension = this.transformDataItem(element)

      state.extensions.data.push(extension)
    })
  },

  /**
   * Set sites filter array, get data from the backend and convert it for better usage
   *
   * @param state
   * @param payload
   */
  setExtensionsFilter (state, payload) {
    state.extensionsFilter = payload
  },
  /**
   * reset the selected updates array
   *
   * @param state
   */
  unsetSelectAll (state) {
    state.selected = []
    state.allSelected = false
  }
}

//
//  █████╗  ██████╗████████╗██╗ ██████╗ ███╗   ██╗███████╗
// ██╔══██╗██╔════╝╚══██╔══╝██║██╔═══██╗████╗  ██║██╔════╝
// ███████║██║        ██║   ██║██║   ██║██╔██╗ ██║███████╗
// ██╔══██║██║        ██║   ██║██║   ██║██║╚██╗██║╚════██║
// ██║  ██║╚██████╗   ██║   ██║╚██████╔╝██║ ╚████║███████║
// ╚═╝  ╚═╝ ╚═════╝   ╚═╝   ╚═╝ ╚═════╝ ╚═╝  ╚═══╝╚══════╝
//
const actions = {

  changeAutoupdateSelected ({ commit, dispatch, state }, payload) {
    state.selected.forEach(s => {
      const current = state.extensions.data.find((e) => {
        return e.id === s
      })
      if (current.data.support_update) {
        dispatch('autoUpdateChange', {
          type: current.data.type,
          element: current.data.element,
          folder: current.data.folder,
          autoupdate: payload
        })
        commit('setAutoupdate', { id: current.data.id, autoupdate: payload })
      }
    })

    commit('unsetSelectAll')
  },

  disableAutoupdateSelected ({ dispatch }) {
    dispatch('changeAutoupdateSelected', 0)
  },

  enableAutoupdateSelected ({ dispatch }) {
    dispatch('changeAutoupdateSelected', 1)
  },

  /**
   * Get extensions filter for the view
   *
   * @param commit
   * @param state
   * @param payload
   *
   * @returns {Promise<any>}
   */
  getExtensionsFilter ({ commit, state }, payload) {
    return new Promise((resolve, reject) => {
      this._vm.axios.get('/api/accountextensionsfilter', { params: payload })
        .then(response => {
          commit('setExtensionsFilter', response.data)
          resolve(response.data)
        }
        )
    })
  },

  /**
   * Get items for the view
   *
   * @param commit
   * @param state
   * @param payload
   *
   * @returns {Promise<any>}
   */
  getExtensions ({ commit, state }, payload) {
    return new Promise((resolve, reject) => {
      this._vm.axios.get(
        '/api/accountextensions?page=', { params: payload })
        .then(response => {
          commit('setExtensions', response.data)
          resolve(response.data)
        })
    })
  },

  /**
     * Update an extension for a site
     *
     * @param dispatch
     * @param payload   extension id
     */
  updateExtension ({ dispatch }, payload) {
    return new Promise((resolve, reject) => {
      this._vm.axios.get('/api/extension/' + payload + '/update').then(
        response => {
          let result = {
            'data': response.data.data,
            'context': {
              'source': 'local',
              'type': 'extension',
              'euid': payload
            }
          }
          resolve(result)
        }
      )
    })
  },

  toggleExtensionIgnoreState ({ dispatch }, payload) {
    return new Promise((resolve, reject) => {
      this._vm.axios.get('/api/extension/' + payload + '/toggleignore').then(
        response => {
          let result = {
            'data': response.data.data,
            'context': {
              'source': 'local',
              'type': 'extension',
              'subtype': 'ignore-update',
              'euid': payload
            }
          }
          resolve(result)
        }
      )
    })
  },

  autoUpdateChange ({ dispatch }, payload) {
    return new Promise((resolve, reject) => {
      this._vm.axios.post('/api/extension/autoupdate', payload).then(
        response => {
          let result = {
            'data': response,
            'context': {
              'source': 'local',
              'type': 'extension',
              'subtype': 'auto-update'
            }
          }
          resolve(result)
        })
    })
  },

  autoUpdateChangeById ({ dispatch }, payload) {
    return new Promise((resolve, reject) => {
      this._vm.axios.post('/api/extension/autoupdatebyid', payload).then(
        response => {
          let result = {
            'data': response.data.data,
            'context': {
              'source': 'local',
              'type': 'extension',
              'subtype': 'auto-update',
              'euid': payload.id,
              'newState': payload.autoupdate
            }
          }
          resolve(result)
        })
    })
  }
}

//
// ███████╗██╗  ██╗██████╗  ██████╗ ██████╗ ████████╗
// ██╔════╝╚██╗██╔╝██╔══██╗██╔═══██╗██╔══██╗╚══██╔══╝
// █████╗   ╚███╔╝ ██████╔╝██║   ██║██████╔╝   ██║
// ██╔══╝   ██╔██╗ ██╔═══╝ ██║   ██║██╔══██╗   ██║
// ███████╗██╔╝ ██╗██║     ╚██████╔╝██║  ██║   ██║
// ╚══════╝╚═╝  ╚═╝╚═╝      ╚═════╝ ╚═╝  ╚═╝   ╚═╝
//
export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
